import Animated, { type SharedValue, useAnimatedStyle } from "@-/com.npmjs.react-native-reanimated";
import {
  welcomeGalaxyLaunchBackgroundColor,
  welcomeGalaxyLaunchStandInSkyOpacity,
  type WelcomeGalaxyLaunchKind,
} from "#welcome-galaxy-launch";
import type { WelcomeGalaxyPalette } from "#welcome-galaxy-palette";

/**
 * The landing's sky on the page's clock, the stand-in's backdrop (`WelcomeGalaxyStandIn`) until the
 * Skia scene draws the same sky itself: the splash's white turning to the galaxy's, so the handoff
 * from the native splash never shows the page's own colour, or after a sign-out the galaxy's sky
 * closing over the picture of the app. Without a launch it is simply the galaxy's sky.
 */
export function WelcomeGalaxyLaunchSky({
  introTime,
  kind,
  palette,
}: {
  introTime: SharedValue<number>;
  kind: WelcomeGalaxyLaunchKind;
  palette: WelcomeGalaxyPalette;
}) {
  const style = useAnimatedStyle(() => {
    const t = introTime.get();
    return {
      backgroundColor: welcomeGalaxyLaunchBackgroundColor(t, palette, kind),
      opacity: welcomeGalaxyLaunchStandInSkyOpacity(t, kind),
    };
  });
  return <Animated.View className="absolute inset-0" pointerEvents="none" style={style} />;
}
